import * as messageService from "../../services/message.service";
import * as stateService from '../../services/state.service';


const state = {
    stateAll:[],
    stateAllActive:[],
};

const getters = {
    gettStateAll:state => (state.stateAll),
    gettStateAllActive:state => (state.stateAllActive),
};

const actions = {
    async fetchStateAll({ commit } ){
        try {
            const response = await stateService.all();
            commit('setStateAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchStateAllActive({ commit } ){
        try {
            const response = await stateService.allActive();
            commit('setStateAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setStateAll:(state, res) => (
        state.stateAll =  res
    ),
    setStateAllActive:(state, res) => (
        state.stateAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}